//TODO:
import React from 'react';
import { Icon } from '@sabre/spark-react-core';

export const getIcon = setIsLeftGridExpanded => isExpanded => <Icon name={`video-control-${isExpanded ? 'rewind' : 'forward'}`} onClick={() => setIsLeftGridExpanded(!isExpanded)} />;

export const getGridConfig = isLeftGridExpanded => {
    const { leftGridWidth, rightGridWidth } = getLeftAndRightGridWidth(isLeftGridExpanded);
    const { leftContainerCss, rightContainerCss } = getGridCss(isLeftGridExpanded);

    return {
        leftGridWidth,
        rightGridWidth,
        leftContainerCss,
        rightContainerCss
    }
};

const getGridCss = isLeftGridExpanded => {
    if(isLeftGridExpanded) {
        return {
            leftContainerCss: 'col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3',
            rightContainerCss: 'col-xs-12 col-sm-12 col-md-8 col-lg-9 col-xl-9 spark-mar-t-2--lte-sm'
        }
    }

    return {
        leftContainerCss: '',
        rightContainerCss: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'
    };
};

const getLeftAndRightGridWidth = isLeftGridExpanded => {
    const rightGridWidth = isLeftGridExpanded ? 100 : 98;
    const leftGridWidth = 100 - rightGridWidth;

    return {
        leftGridWidth,
        rightGridWidth
    }
};
